export const statesOnly = [
  {
    name: "Abia",
    id: 1,
  },
  {
    name: "Adamawa",
    id: 2,
  },
  {
    name: "Akwa Ibom",
    id: 3,
  },
  {
    name: "Anambra",
    id: 4,
  },
  {
    name: "Bauchi",
    id: 5,
  },
  {
    name: "Bayelsa",
    id: 6,
  },
  {
    name: "Benue",
    id: 7,
  },
  {
    name: "Borno",
    id: 8,
  },

  {
    name: "Cross River",
    id: 9,
  },

  {
    name: "Delta",
    id: 10,
  },

  {
    name: "Ebonyi",
    id: 11,
  },
  {
    name: "Edo",
    id: 12,
  },
  {
    name: "Ekiti",
    id: 13,
  },
  {
    name: "Enugu",
    id: 14,
  },

  {
    name: "Federal Capital Territory",
    id: 15,
  },
  {
    name: "Gombe",
    id: 16,
  },
  {
    name: "Imo",
    id: 17,
  },
  {
    name: "Jigawa",
    id: 18,
  },
  {
    name: "Kaduna",
    id: 19,
  },
  {
    name: "Kano",
    id: 20,
  },
  {
    name: "Katsina",
    id: 21,
  },
  {
    name: "Kebbi",
    id: 22,
  },
  {
    name: "Kogi",
    id: 23,
  },
  {
    name: "Kwara",
    id: 24,
  },
  {
    name: "Lagos",
    id: 25,
  },
  {
    name: "Nasarawa",
    id: 26,
  },
  {
    name: "Niger",
    id: 27,
  },
  {
    name: "Ogun",
    id: 28,
  },
  {
    name: "Ondo",
    id: 29,
  },
  {
    name: "Osun",
    id: 30,
  },
  {
    name: "Oyo",
    id: 31,
  },
  {
    name: "Plateau",
    id: 32,
  },
  {
    name: "Rivers",
    id: 33,
  },
  {
    name: "Sokoto",
    id: 34,
  },
  {
    name: "Taraba",
    id: 35,
  },
  {
    name: "Yobe",
    id: 36,
  },
  {
    name: "Zamfara",
    id: 37,
  },
];
